import Bugsnag from '@bugsnag/js'
import config from 'config'

const embeddableCards = {
  EndpointError(message) {
    this.name = 'EndpointError'
    this.message = message || ''
  },

  getContent(endpoint, authorization, context, useProxy = true) {
    const url = useProxy
      ? `${config.embeddable_cards_url}?url=${encodeURIComponent(endpoint)}`
      : endpoint
    const headers = {
      Authorization: authorization,
      'Content-Type': 'application/json',
    }
    const body = JSON.stringify(context)
    return fetch(url, {
      method: 'POST',
      headers,
      body,
    })
      .catch(err => {
        // If we have to catch here it was a problem with the GQL proxy and we want to log it
        Bugsnag.notify(err)
        throw err
      })
      .then(res => {
        return Promise.all([
          Promise.resolve(res.status),
          res.text(),
          Promise.resolve(res.headers.get('Still-Loading') === 'true'),
        ])
      })
      .then(res => {
        const [status, text, stillLoading] = res
        if (status >= 300) {
          throw new embeddableCards.EndpointError(text)
        }
        if (status === 200 && text === '') {
          throw new embeddableCards.EndpointError('No response data')
        }
        const wrapper = document.createElement('div')
        wrapper.innerHTML = text
        return {
          content: wrapper.innerHTML,
          stillLoading,
        }
      })
  },
}
embeddableCards.EndpointError.prototype = Error.prototype
export default embeddableCards
